
























































import Login from './login.vue'
import Binding from './bingding.vue'
import Register from './register.vue'
import { Component, Vue } from 'vue-property-decorator'
import UserModule from '@api/module/customer/user/UserModule'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'

@Component({
  components: {
    Login,
    Register,
    Binding
  }
})
export default class extends Vue {
  bindTitle = '绑定手机'
  get isShowBinding() {
    return LoginDialogModule.showBinding
  }

  set isShowBinding(val: boolean) {
    LoginDialogModule.setShowBindingWeixinDialog(val)
  }

  get isShowLogin() {
    return LoginDialogModule.showLogin
  }

  set isShowLogin(value: boolean) {
    LoginDialogModule.setShowLoginDialog(value)
  }

  get isShowRegister() {
    return LoginDialogModule.showRegister
  }

  set isShowRegister(value: boolean) {
    LoginDialogModule.setShowRegisterDialog(value)
  }

  get userPhoto() {
    return UserModule.userInfo.displayPhotoUrl || require('@design/portal/jskq/assets/images/head-default.jpg')
  }

  loginResult(result: boolean) {
    this.closeLogin()
    if (result) {
      UserModule.queryUserInfo()
    }
  }

  toForget() {
    LoginDialogModule.setShowLoginDialog(false)
    this.$router.push('/forgot-password')
  }

  toLogin() {
    LoginDialogModule.setShowLoginDialog(true)
    LoginDialogModule.setShowRegisterDialog(false)
  }

  toRegistry() {
    LoginDialogModule.setShowLoginDialog(false)
    LoginDialogModule.setShowRegisterDialog(true)
  }

  closeLogin() {
    LoginDialogModule.setShowLoginDialog(false)
    LoginDialogModule.setShowBindingWeixinDialog(false)
  }

  closeRegister() {
    LoginDialogModule.setShowRegisterDialog(false)
    UserModule.queryUserInfo()
  }

  changeBindTitle(val: boolean) {
    this.bindTitle = val ? '确认帐号密码' : '绑定手机'
  }
}
